module.exports = __webpack_public_path__ + "static/media/MOTIVATION_MIXED_LOW.a21fbd09.md";